const MINUTE = 60 * 1000;
export const STALE_TIME = {
  HALF_MINUTE: 30 * 1000,
  SHORT: MINUTE,
  DYNAMIC: 5 * MINUTE,
  STABLE: 15 * MINUTE
};
